/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * IntegrationListenerForm
 *
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, DetailHeader, DetailsPanelMessage, InputField, SelectField, Toast, Detail } from 'cx-ui-components';
import gIcon from "../../../../assets/icons/g-icon.png";
import msIcon from '../../../../assets/icons/ms_icon.png';
import styled from "styled-components";
import { getRelativeUrl, getXHRInstance, msLogin } from "../../../../redux/modules/entities/integrations/utilities";

const GoogleLoginButton = styled(Button)`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 160px;
  padding: 5px;
`;

const GoogleIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 7px;
`;

const MsLoginButton = styled(Button)`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 160px;
  padding: 5px;
`;

const MsIcon = styled.img`
  height: 16px;
  width: auto;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 7px;
`;

const OauthCredentialId = styled.input``;

export default class IntegrationListenerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listenerType: this.props.initialValues.get('listenerType'),
      googleButtonLabel: 'Sign In with Google',
      msButtonLabel: 'Sign In with Microsoft',
      oauthCredential: undefined,
      msNotificationVisible: false,
    };
  }

  handleListenerType = e => {
    this.setState({ listenerType: e.target.value });
  };

  googleLogin = (e) => {
    e.preventDefault();
    if (this.state.oauthCredential) {
      const body = {
        client_id: this.props.googleOauthClientId,
        client_secret: this.props.googleOauthClientSecret,
        grant_type: 'refresh_token',
        refresh_token: this.state.oauthCredential.refreshToken
      };
      this.googleRequestToken(body);
    } else {
      let googleClient;
      const baseUrl = getRelativeUrl();
      const self = this;

      googleClient = window.google.accounts.oauth2.initCodeClient({
        client_id: this.props.googleOauthClientId,
        scope: 'https://mail.google.com/',
        ux_mode: 'popup',
        callback: (codeResponse) => {
          if (codeResponse && codeResponse.code) {
            const body = {
              client_id: self.props.googleOauthClientId,
              client_secret: self.props.googleOauthClientSecret,
              code: codeResponse.code,
              grant_type: 'authorization_code',
              access_type: 'offline',
              redirect_uri: baseUrl
            };
            this.googleRequestToken(body);
          } else if (codeResponse && codeResponse.error) {
            Toast.error('Sign In with Google failed. Please verify your credentials and that you granted the access.');
          }
        },
      });

      googleClient.requestCode();
    }
  };

  googleRequestToken = (body) => {
    const self = this;
    const xhr = getXHRInstance(body);
    xhr.onreadystatechange = function (response) { // Call a function when the state changes.
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        if (response && response.target && response.target.response) {
          let responseObject = JSON.parse(response.target.response);
          if (body.grant_type === 'authorization_code') {
            responseObject.tokenAcquiredTime = new Date().toISOString();
            // self.props.setSubEntityOauthToken(JSON.stringify(responseObject));
            Toast.success('Google Access Token acquired successfully.');
          } else {
            responseObject.refreshToken = body.refresh_token;
            responseObject.tokenAcquiredTime = new Date().toISOString();
            // self.props.setSubEntityOauthToken(JSON.stringify(responseObject));
            Toast.success('Google Access Token refreshed successfully.');
          }
        }
      } else {
        if (response && response.target && response.target.response) {
          let responseObject = JSON.parse(response.target.response);
          if (responseObject.error) {
            if (self.state.oauthCredential) {
              self.setState({ googleButtonLabel: 'Sign In with Google' });
              self.setState({ oauthCredential: undefined });
              // self.props.setSubEntityOauthToken('');
              Toast.error(`Google Access Token process failed. (${responseObject.error}) ${responseObject.error_description}`);
            }
          }
        }
      }
    }
    xhr.send(JSON.stringify(body));
  };

  msLogin = (e) => {
    e.preventDefault();
    msLogin(this.state.baseUrl, this.props.msOauthClientId, this.props.msOauthClientSecret)
      .then((response) => {
        const msWindow = window.open(
          response,
          'cxengageMsWindow',
          'width=500,height=600'
        );
      })
      .catch((error) => {
        const errorMessage = error ? error : '';
        Toast.error(`Microsoft Access Token process failed. ${errorMessage}`);
      });
  };

  componentDidMount() {
    window.postMessage({ fromListener: { value: true } }, window.location.origin);

    let baseUrl = window.location.origin;
    const relativeUrl = window.location.href;
    if (baseUrl.indexOf('frontend-prs') > 0) {
      baseUrl = relativeUrl.substring(0, relativeUrl.indexOf('#'));
    }
    this.setState({ baseUrl });
  }

  componentWillUnmount() {
    window.postMessage({ fromListener: { value: false } }, window.location.origin);
  }

  render() {
    const { initialValues, isSaving, integrationType, incomingType } = this.props;
    return (
      <Fragment>
        <DetailHeader text="Properties" />
        {integrationType === 'email' && (
          <Fragment>
            <InputField
              name="properties.email"
              label="Email *"
              componentType="input"
              inputType="text"
              data-automation="integrationsListenersEmail"
              disabled={isSaving}
            />
            {incomingType === 'oauth-google' && (
              <>
                <GoogleLoginButton
                  onClick={(e) => this.googleLogin(e)}
                >
                  <GoogleIcon
                    src={gIcon}
                  />
                  {this.state.googleButtonLabel}
                </GoogleLoginButton>
                <InputField
                  name="properties.oauthCredential"
                  label="Google Access Token *"
                  componentType="input"
                  dataType="password"
                  inputType="text"
                  placeholder="Google Oauth Credential..."
                  data-automation="oauthCredentialInput"
                  disabled
                  maskValue
                />
                <DetailsPanelMessage
                  text={`The email and Google Access token should not have to be updated again. Only modify these fields when necessary. If you update the email, Sign In with Google using the new account.`}
                  type="warning"
                />
              </>
            )}
            {incomingType === 'oauth-ms' && (
              <>
                <MsLoginButton
                  onClick={(e) => this.msLogin(e)}
                >
                  <MsIcon
                    src={msIcon}
                  />
                  {this.state.msButtonLabel}
                </MsLoginButton>
                <Detail label="Access Token generated by: " value={this.props.msOauthPreferredUsernameListener} />
                <InputField
                  name="properties.oauthCredential"
                  label="Microsoft Access Token *"
                  componentType="input"
                  dataType="password"
                  inputType="text"
                  placeholder="Microsoft Oauth Credential..."
                  data-automation="oauthCredentialInput"
                  disabled
                  maskValue
                />
                <OauthCredentialId
                  name="properties.oauthCredentialId"
                  type="hidden"
                  data-automation="oauthCredentialIdInput"
                />
                {(this.props.msOauthPreferredUsernameListener !== this.props.currentEmail) &&
                  <DetailsPanelMessage
                    text={`The email used to generate the Microsoft Access token it is different than the Email.`}
                    type="error"
                  />
                }
                <DetailsPanelMessage
                  text={`The email and Microsoft Access token should not have to be updated again. Only modify these fields when necessary. If you update the email, Sign In with Microsoft using the new account.`}
                  type="warning"
                />
              </>
            )}
            {(incomingType !== 'oauth-google' && incomingType !== 'oauth-ms') && (
              <InputField
                name="properties.password"
                label="Password *"
                componentType="input"
                dataType="password"
                inputType="text"
                data-automation="integrationsListenersPassword"
                disabled={isSaving}
                maskValue
              />
            )}
          </Fragment>
        )}
        {integrationType === 'facebook' && (
          <Fragment>
            <InputField
              name="properties.pageToken"
              label="Page Token *"
              componentType="input"
              inputType="text"
              data-automation="integrationsListenersPageToken"
              disabled={isSaving}
            />
            <InputField
              name="properties.pageId"
              label="Page ID *"
              componentType="input"
              inputType="text"
              data-automation="integrationsListenersPageId"
              disabled={isSaving}
            />
          </Fragment>
        )}
        {integrationType === 'salesforce' && (
          <Fragment>
            <SelectField
              name="listenerType"
              label="Listener Type"
              placeholder="Select a listener Type..."
              disabled={isSaving || !!initialValues.get('id')}
              data-automation="listenerType"
              options={[
                { label: 'Email to Case', value: 'emailToCase' },
                { label: 'OmniChannel', value: 'omnichannel' }
              ]}
              onChange={this.handleListenerType}
              required
            />
            {(!this.state.listenerType || this.state.listenerType === 'emailToCase') && (
              <Fragment>
                <InputField
                  name="properties.topic"
                  label="Topic *"
                  componentType="input"
                  inputType="text"
                  data-automation="integrationsListenersTopic"
                  disabled={isSaving}
                />
                <InputField
                  name="properties.type"
                  label="Salesforce Object Type *"
                  componentType="input"
                  inputType="text"
                  data-automation="integrationsListenersType"
                  disabled
                />
              </Fragment>
            )}
            {this.state.listenerType === 'omnichannel' && (
              <Fragment>
                <InputField
                  name="properties.routingTopics[0].topic"
                  label="Routing Topic *"
                  componentType="input"
                  inputType="text"
                  data-automation="integrationsListenersRoutingTopic"
                  disabled={isSaving}
                />
                <InputField
                  name="properties.agentWorkTopic"
                  label="Agent Work *"
                  componentType="input"
                  inputType="text"
                  data-automation="integrationsListenersAgentWorkTopic"
                  disabled={isSaving}
                />
              </Fragment>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

IntegrationListenerForm.propTypes = {
  currentEmail: PropTypes.string,
  googleOauthClientId: PropTypes.string,
  googleOauthClientSecret: PropTypes.string,
  incomingType: PropTypes.string,
  initialValues: PropTypes.object,
  integrationEmail: PropTypes.string,
  integrationType: PropTypes.string,
  isSaving: PropTypes.bool,
  msOauthClientId: PropTypes.string,
  msOauthClientSecret: PropTypes.string,
  msOauthPreferredUsernameListener: PropTypes.string,
  oauthCredential: PropTypes.any,
};
